<template>
<div>
  <Card v-if="!selectedTraining?.userWorksheetSummaryList" class="list-entity d-flex gap-2 justify-content-between align-items-center px-2 py-1"> 
      <LoaderComponent/>
  </Card>
  <div class="p-2" v-else>
    <div class="list-entity d-flex gap-2 justify-content-between align-items-center px-2 py-1">
     <div class="d-flex gap-2 align-items-center"> <img :src="selectedTraining.training.trainingImg" v-if="selectedTraining.training.trainingImg" alt="" class="training-img" />
     <img v-else src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU" class="training-img"/>
      <div class="">
        <p class="qb-entity-title m-0">{{ selectedTraining.training.trainingName }}</p>
        <p class="qb-entity-subtitle m-0">{{ selectedTraining.totalElements }} Enrolled</p>
      </div>
     </div>

     
     
    </div>
    <hr class="divider border" />
    <div class="mb-0">
        <Button label="User" @onClick="toggleTab('table')" :class="[toggletab==='table' ? 'toggle' : '','toggle-tab']"/>
        <Button label="Dashboard"  @onClick="toggleTab('chart')" :class="[toggletab==='chart' ? 'toggle' : '','toggle-tab']"/>
      </div>
      <div class="box p-2">
    <div v-if="toggletab==='chart'">
    <performance-dashboard></performance-dashboard>
    </div>
    <div v-if="toggletab==='table'">
    <div class="d-flex tab-container gap-2 p-2">
              <div :class="[(activetab=='')? 'active': '' ,'tab']" @click="getTraining('')">All</div>
              <div :class="[(activetab=='COMPLETED')? 'active': '' ,'tab']" @click="getTraining('COMPLETED')">Completed</div>
              <div :class="[(activetab=='IN_PROGRESS')? 'active': '' ,'tab']" @click="getTraining('IN_PROGRESS')">In Progress</div>
              <div :class="[(activetab=='NOT_YET_STARTED')? 'active': '' ,'tab']" @click="getTraining('NOT_YET_STARTED')">Not Yet Started</div>
      </div>
    <div v-if="selectedTraining.userWorksheetSummaryList && selectedTraining.userWorksheetSummaryList.length > 0">
      <div class="table-responsive-xl">
      <table class="table">
        <thead>
          <tr>
            <th class="small">Employee</th>
            <th class="small">Progress</th>
            <th class="small">Start Date</th>
            <th class="small">Due Date</th>
            <th class="small">Complete Date</th>
            <th class="small">Last Submission</th>
            <th class="small">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in selectedTraining.userWorksheetSummaryList" class="" :key="index" :userData="data">
            <td>
              <div class="d-flex align-items-center">
                <div>
                  <img :src="data.profileImg" alt="" class="qb-avatar me-2" v-if="data.profileImg"/>
                  <img :src="`https://avatars.dicebear.com/api/initials/${data.name}.svg`" alt="" class="qb-avatar me-2" v-else />
                </div>
                <div>
                  <p class="title-text my-0">{{ data.name }}</p>
                  <p class="title-sub-text my-0">{{ data.emailId }}</p>
                </div>
              </div>
            </td>
            <td class="">
              <div class="align-items-center my-auto">
                <div class="progress-outer-bar">
                  <div
                    class="progress-inner-bar"
                    :style="{ width: getPercentage(data.totalNoOfTasks, data.completedTasks) + '%' }"
                  ></div>
                </div>
                <span class="percentage-text">{{
                  getPercentage(data.totalNoOfTasks, data.completedTasks) + "% Completed"
                }}</span>
              </div>
            </td>
            <td>
              <p class="date-text my-0">{{ formatDate(data.startDate) }}</p>
            </td>
            <td>
              <p class="date-text my-0">{{ formatDate(data.endDate) }}</p>
            </td>
            <td>
              <Badge
                :label="data.completedDate ? formatDate(data.completedDate) : 'Not Completed'"
                class="badge-rounded badge-rounded-grey-outline ms-0 p-0" 
              />
            </td>
            <td>
              <Badge
                :label="data.lastSubmissionDate ? formatDate(data.lastSubmissionDate) : 'Not Started'"
                class="badge-rounded badge-rounded-grey-outline ms-0 p-0"
              />
            </td>
            <td>
              <Button label="View" class="qb-btn qb-btn-outline-sm ms-2" @onClick="setActiveUser(data)" />
            </td>
          </tr>
        </tbody>
      </table>
      </div>
     <div class="m-2">
            <Pagination :totalRecords="selectedTraining.totalElements" :pageSize="10" @pageChange="pageChange" />
          </div>
    </div>
    <div v-else>
      <p class="text-center">No User found</p>
    </div>


    <Drawer @close="toggleDrawer" :align="align" :closeable="true" :maskClosable="true">
      <div v-if="openDrawer" class="drawer-content">
        <!-- <h1 v-for="(data, index) in 50" :key="index">OPened</h1> -->
        <div class="d-flex justify-content-between col-8 pe-3">
        <Button label="Close" class="qb-btn qb-btn-outline-sm ms-2" @onClick="toggleDrawer" />
        <div><p class="my-0 title-text">Name : {{this.activeUser.name}}</p></div>
        </div>

        <div class="row">
          <div class="col-8">
            <div class="p-3">
              <div class="d-flex justify-content-between">
                <div class="flex-fill">
              <div class="d-flex mt-2 align-items-center">
                <div>
                  <img :src="worksheet.trainingImg" alt="" class="training-img me-2" v-if="worksheet.trainingImg"/>
                  <img v-else src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU" class="training-img me-2"/>
                </div>
                <div>
                  <p class="title-text my-0">{{ worksheet.name }}</p>
                </div>
              </div>
              <div class="col-3 align-items-center mt-3">
                <div class="progress-outer-bar">
                  <div
                    class="progress-inner-bar"
                    :style="{ width: getPercentage(activeUser.totalNoOfTasks, activeUser.completedTasks) + '%' }"
                  ></div>
                </div>
                <span class="percentage-text">{{
                  getPercentage(activeUser.totalNoOfTasks, activeUser.completedTasks) + "% Completed"
                }}</span>
              </div>
                </div>
                <div class="flex p-3 info-box" v-if="worksheet.status==='COMPLETED' && score==null">

                    <div class="d-flex flex-column align-items-end m-1" v-if="!showScore">
                      <div class="mb-2"><p class="title-sub-text my-0">Would you like to score this Training ?</p></div>
                      <div class="d-flex gap-2">
                        <Button label="Yes" class="qb-btn qb-btn-black-sm" @onClick="toggleScore()"/>
                      </div>
                    </div>

                    <div class="d-flex flex-column align-items-end" v-if="showScore">
                      <score-board @score="(val)=>setScore(val,user,worksheet)">
                      </score-board>
                    </div>

                </div>
                <div v-if="worksheet.status==='COMPLETED' && score!=null" class="flex p-3 title-text">
                  <p class="my-0 ">Score : {{score}} / 10</p>
                </div>
              </div>
              <div class="worksheet-scroll mt-2">
                <div class="p-2">
                  <p class="my-1 ms-2 sub-heading">Description</p>
                  <div class="my-1 p-2 title-sub-text" v-html="worksheet.description"></div>

                  <div class="mt-4">
                    <p class="my-0 ms-2 sub-heading">Training Content</p>
                    <div class="p-3">
                      <div v-for="(day, index) in worksheet.worksheet" :key="index">
                        <p class="task-detail-module-identifier my-3">
                          <font-awesome-icon icon="fa-solid fa-cube" /> DAY {{ index + 1 }} -
                          {{ day.status.replaceAll("_", " ") }}
                        </p>
                        <div class="timeline-box">
                          <TaskProgressListComponent
                            :day="day"
                            :dayTask="dayTask"
                            :index="index"
                            :lastIndex="lastIndex"
                            v-for="(dayTask, index) in day.taskList"
                            :key="index"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div>
              <p class="my-3 sub-heading">Training Comments</p>
              <div class="comment-section">
                <div class="comment-box">
                  <div class="comment-body">
                    <div v-for="(data, index) in commentsForSelectedWorksheet" :key="index">
                      <div :class="['single-chat', data.userId !== user.userId ? 'chat-right' : 'chat-left']">
                        <div class="p-2">
                          <p class="title-text my-0">
                            {{ data.userName }}
                          </p>
                          <p class="title-sub-text my-0">{{ data.comment }}</p>
                        </div>
                        <div class="comment-footer py-1 px-2">
                          <p class="comment-date my-0">{{ formatDate(data.date) }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="message-bar d-flex align-items-center">
                    <Input placeholder="Type your comment" type="text" class="flex-grow-1" v-model="message" />
                    <Button
                      label="Send"
                      class="qb-btn qb-btn-primary-md ms-2"
                      :disabled="messageValidation"
                      @onClick="sendMessage"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
    </div>
      </div>
  </div>
  </div>
</template>

<script>
import Vue from "vue";
import Drawer from "vue-simple-drawer";
import Input from "../components/TextFieldComponent.vue";
import Badge from "../components/BadgeComponent.vue";
import TaskProgressListComponent from "../components/TaskProgressListComponent.vue";
import Pagination from "../components/PaginationComponent.vue"
import LoaderComponent from "../components/LoaderComponent"
import ScoreBoard from "../components/ScoreBoard.vue"
import PerformanceDashboard from "../components/PerformanceDashboard.vue"
// import UserListByTrainingComponent from "../components/UserListByTrainingComponent.vue";
import { createNamespacedHelpers } from "vuex";
import Button from "../components//ButtonComponent.vue";
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers("Training");
const { mapActions: workSheetMapActions, mapGetters: workSheetMapGetters } = createNamespacedHelpers("WorkSheet");
const { mapGetters: authMapGetters } = createNamespacedHelpers("Auth");

export default {
  name: "CreatedTrainingDetailPage",
  data() {
    return {
      openDrawer: false,
      align: "right",
      // employeeSearchTerm: "",
      activeUser: {},
      message: "",
      activetab:"",
      showScore:false,
      toggletab:'table'
    };
  },
  components: {
    Input,
    Button,
    Badge,
    Drawer,
    Pagination,
    TaskProgressListComponent,
    LoaderComponent,
    PerformanceDashboard,
    ScoreBoard
    // UserListByTrainingComponent,
  },
  computed: {
    ...trainingMapGetters({
      selectedTraining: "getSelectedTrainingForUserSummary",
      commentsForSelectedWorksheet: "getCommentsForSelectedWorkSheet",
    }),
    ...workSheetMapGetters({
      worksheet: "getWorkSheet",
      score: "getWorksheetScore"
    }),
    ...authMapGetters({
      user: "getUser",
    }),
    messageValidation() {
      return this.message === "";
    },
  },
  methods: {
    navigateWorksheet(worksheetId) {
      this.$div({
        name: "WorksheetDetailPage",
        params: {
          worksheetId: worksheetId,
        },
      });
    },
    ...workSheetMapActions({
      getWorkSheetDetails: "GET_WORKSHEET_BY_ID_BY_ADMIN",
      createNewComment: "CREATE_COMMENT_FOR_WORKSHEET",
      setWorksheetScore: "SET_WORKSHEET_SCORE",
      getWorksheetScore: "GET_WORKSHEET_SCORE"
    }),
    ...trainingMapActions({
      getCommentsByWorksheetId: "GET_COMMENTS_BY_WORKSHEET_ID",
      getUsersForEnrolledTraining: "GET_USERS_FOR_ENROLLED_TRAINING",
    }),
    setActiveUser(user) {
      this.activeUser = user;
      this.getWorkSheetDetails({id:user.worksheetId,userId:this.user.userId});
      this.getCommentsByWorksheetId(user.worksheetId);
      this.getWorksheetScore(user.worksheetId)
      this.toggleDrawer();
      this.showScore=false;
    },
    getTraining(status){
        this.activetab=status
        this.getUsersForEnrolledTraining({id:this.selectedTraining.training.trainingId, status})
    },
    toggleDrawer() {
      this.openDrawer = !this.openDrawer;
      if (!this.openDrawer) {
        this.activeUser = {};
        this.getUsersForEnrolledTraining({id:this.selectedTraining.training.trainingId})
      }
      // this.toggleScore()
    },
    pageChange(page){
       this.getUsersForEnrolledTraining({id:this.selectedTraining.training.trainingId,status:this.activetab,page})
    },
    sendMessage() {
      const payload = {
        comment: this.message,
        userId: this.user.userId,
        worksheetId: this.activeUser.worksheetId,
      };

      this.createNewComment({
        payload,
        successCallback: ({ data }) => {
          if (data.status === "OK") {
            Vue.$toast.success("Comment Posted Successfully");
            this.getCommentsByWorksheetId(this.activeUser.worksheetId);
          } else {
            Vue.$toast.error("Something went wrong");
          }
        },
        errorCallback: (err) => {
          Vue.$toast.error(err.message);
        },
      });
      this.message = "";
    },

    structureData(data) {
      return data.replaceAll("_", " ");
    },
    getPercentage(totalTask, completedTask) {
      return [
        isNaN(Number(Math.round((completedTask / totalTask) * 100)))
          ? 0
          : Number(Math.round((completedTask / totalTask) * 100)),
      ];
    },
    toggleScore(){
      // alert("fbvef")
        this.showScore=!this.showScore;
    },
    toggleTab(val){
      this.toggletab=val
    },
    setScore(val,user,worksheet){
      console.log(val,user,worksheet,this.$route)
      let payload={
        score:val,
        userId: worksheet.userId,
        id: worksheet.worksheetId,
        trainingId:this.$route.query.trainingId,
        updatedBy:user.userId
        
      }
      this.setWorksheetScore({payload,
      successcallback:(res)=>{
        console.log(res)
        this.getWorksheetScore(worksheet.worksheetId)
        Vue.$toast.success("Score added successsfully")
      },
      errorcallback:(err)=>{
        Vue.$toast.error(err.message)
      }
      })
      // alert("Score is set to "+val)
    }
  },
  watch:{
    $route(){
        this.activetab=""
        this.toggletab="table"
    }
  },
  // updated(){
  //       this.loader()
  //   }
  // watch: {
  //   employeeSearchTerm() {
  //     this.getUsersForEnrolledTraining({ id: this.selectedTraining.training.trainingd, name: this.employeeSearchTerm });
  //   },
  // },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";
.info-box{
  border-radius:7px;
  border: 1px solid $light-200;
  background-color: rgb(237, 236, 236);
}
.title-text {
  font-size: $font-size-md;
  font-weight: $font-weight-bold;
  color: $dark-300;
}

.task-detail-module-identifier {
  font-size: $font-size-sm;
  color: $light-600;
  font-weight: $font-weight-bold;
  margin: 0px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.sub-heading {
  font-size: $font-size-lg;
  color: $dark-300;
  font-weight: 600;
}

.drawer-content {
  margin-top: 40px;
}

.title-sub-text {
  font-size: $font-size-md;
  color: $dark-200;
}
.timeline-box {
  border-left: 1px solid $dark-200;
  padding-left: 10px;
  margin-left: 10px;
}

.qb-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.progress-outer-bar {
  width: 100%;
  height: 10px;
  background-color: $light-200;
  border-radius: 5px;
}

.worksheet-scroll {
  max-height: 550px;
  overflow: auto;
  border: 1px solid $light-200;
}

.progress-inner-bar {
  height: 100%;
  background-color: $primary-100;
  border-radius: 5px;
}

.date-text {
  font-size: $font-size-sm;
  color: $dark-200;
}

.comment-date {
  font-size: $font-size-xs;
  color: $dark-200;
}

.percentage-text {
  font-size: $font-size-sm;
  font-weight: $font-weight-bold;
  color: $dark-300;
}

.comment-body {
  border: 1px solid $light-200;
  border-radius: 5px;
  height: 500px;
  overflow-y: auto;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.single-chat {
  border: 1px solid $light-200;
  border-radius: 5px;
  // padding: 10px;
  margin-bottom: 15px;
  min-width: 250px;
  max-width: 300px;
}

.chat-right {
  float: left;
}

.chat-left {
  float: right;
}

.comment-footer {
  background-color: $light-100;
}

.training-img {
  width: 60px;
  height: 35px;
  border-radius: 5px;
}

.qb-entity-subtitle {
  font-size: $font-size-sm;
  color: $dark-200;
  font-weight: $font-weight-bold;
}
.tab {
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-2;
  width: fit-content;
  border-radius: $field-border-radius-high;
  padding: 3px 10px;
  text-decoration: none;
  background-color: $light-300;
  color: $dark-300;
}

.tab:hover {
  cursor: pointer;
}

.active{
  color: $light-300;
  background-color: $dark-300;
}
.toggle-tab{
  font-size: $font-size-lg;
  font-weight: $font-weight-normal-2;
  width: fit-content;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 3px 10px;
  text-decoration: none;
  background-color: $light-300;
  color: $dark-300;
  border:none;
  background: transparent;
}
.toggle{
  color: $primary-100;
  background-color: white;
  border:1px solid $light-400;
  border-bottom:none;
}
.box{
  border:none;
  border-top:1px solid $light-400;
  max-height:550px;
  overflow: scroll;
}
</style>
